import React from 'react';

import PropTypes from 'prop-types';

import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import { useFulfillmentPlannerContext } from '../context';
import { useConfirmationTypesForService } from '../hooks/use-confirmation-types-for-service';

import ConfirmationOption from './index';

const FulfillmentPlannerContextConfirmationWrapper = ({ id, dropdownMenuType }) => {
  const { onConfirmationChange, otherShippingOptions, serviceIdAndSellerLabelProviderId, serviceCollectionGuid } =
    useFulfillmentPlannerContext();

  const selectedConfirmationOptionId = otherShippingOptions.confirmationEnumId?.toString();
  const confirmationOptions = useConfirmationTypesForService(serviceIdAndSellerLabelProviderId.serviceId);

  return (
    <ConfirmationOption
      confirmationOptions={confirmationOptions}
      disabled={!!serviceCollectionGuid}
      dropdownMenuType={dropdownMenuType}
      id={id}
      onChange={onConfirmationChange}
      selectedConfirmationOptionId={selectedConfirmationOptionId}
    />
  );
};

export default FulfillmentPlannerContextConfirmationWrapper;

FulfillmentPlannerContextConfirmationWrapper.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
};
